export default {"src":"/pro/_next/static/media/skatefi-logo.cedbc5ca.svg","height":61,"width":346,"blurWidth":0,"blurHeight":0};